import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addCoupon: builder.mutation({
      query: (body) => ({
        url: END_POINTS.addCoupon,
        method: "POST",
        body,
      }),
    }),

    getCouponById: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.getCouponById}${id}/`,
        method: "POST",
      }),
    }),

    getCoupon: builder.mutation({
      query: (body) => ({
        url: END_POINTS.getAllCoupon,
        method: "POST",
        body,
      }),
    }),

    updateCoupon: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCoupon}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    updateCouponStatus: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCoupon}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteCoupon: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCoupon}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddCouponMutation,
  useLazyGetCouponByIdQuery,
  useGetCouponMutation,
  useUpdateCouponMutation,
  useUpdateCouponStatusMutation,
  useDeleteCouponMutation,
} = discountApi;
